import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const GroupAttributeServiceConfig = {
  name: "GroupAttribute",
  annotations: []
} as ServiceConfig;